import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PlatformAPIClientAuthorizationService } from '@services/platform-api-client-authorization.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(PlatformAPIClientAuthorizationService);

  const isCallback = state.url.startsWith('/authorization/callback');
  const hasToken = authService.getPKCETokenFromSession();
  if (!hasToken && !isCallback) {
    router.navigate(['/']);
    return false;
  }

  return true;
};
